<template>
  <div class="">
    <z-modal
      :loading="loading"
      :visible="visible"
      :width="434"
      title="新建提问"
      destroyOnClose
      @submit="addQa"
      @close="$emit('update:visible', false)"
    >
      <a-form-model ref="addForm" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="内容" prop="content">
          <a-input v-model="form.content" type="textarea" :rows="6" />
        </a-form-model-item>
        <a-form-model-item label="图片">
          <upload listType="picture-card" path="img/art/" @uploadChange="uploadChange"></upload>
        </a-form-model-item>
      </a-form-model>
    </z-modal>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import upload from '@/components/Upload'
import { addTheme } from '@/api/myQa'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // loading: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      loading: false,
      form: {
        content: '',
        photos: ''
      },
      rules: {
        content: [{ required: true, message: '提问内容不能为空', trigger: 'blur' }]
      }
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.form.content = ''
        this.form.photos = ''
      }
    }
  },
  components: {
    zModal,
    upload
  },
  methods: {
    // async addQa(ev) {
    //   console.log('add', ev)
    //   try {
    //     this.loading = true
    //     const res = await addTheme({
    //       ...ev,
    //       classesId: this.classesId,
    //       planclassesId: this.planclassesId
    //     })
    //     res && this.$message.success('添加成功')
    //     this.visible = false
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    addQa() {
      const planclassesId = this.$parent.planclassesId
      const classesId = this.$parent.classesId
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          try {
            this.loading = true
            const res = await addTheme({
              ...this.form,
              classesId,
              planclassesId
            })
            res && this.$message.success('添加成功')
            this.$emit('update:visible', false)
            this.$emit('refresh')
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        }
      })
    },
    uploadChange(ev) {
      this.form.photos = ev.join(',')
    }
  }
}
</script>
<style lang="less" scoped>
.ant-form {
  margin-top: 16px;
  .ant-input {
    background: #f5f6fa;
    border-radius: 15px;
    border: none;
  }
}
</style>
